import React from "react";

import { MenuWrapper } from "../orderHistory.styles";
import { NormalText } from "../../../common/common.styles";

const menuItems = ["Open Orders", "Settled Orders", "Saved Orders"];

const MenuTabs = ({ onSetActivePage, activePage }) => {
    return (
        <MenuWrapper>
            <div className="catalogue__menu-items-wrap">
                {menuItems.map((item, index) => (
                    <div
                        className={
                            activePage === index
                                ? "catalogue__menu-active"
                                : "catalogue__menu-inactive"
                        }
                        onClick={() => onSetActivePage(index)}
                        key={item + index}
                    >
                        <NormalText>{item}</NormalText>
                        {activePage === index && <div />}
                    </div>
                ))}
            </div>
        </MenuWrapper>
    );
};

export default MenuTabs;
